var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-img-info"},[_c('div',{staticClass:"img-info"},[_c('img',{attrs:{"src":require('../../assets/background/wait.svg'),"alt":"wait for your link"}}),_c('span',[_vm._v("Wait a moment, creating link")])])])}
var staticRenderFns = []

export { render, staticRenderFns }